
import Vue, { PropType } from "vue";
import { Menu } from "@ambii-com/core";
import SelectedMenuChip from "~/components/pages/appointment/SelectedMenuChip.vue";

export default Vue.extend({
  components: { SelectedMenuChip },
  props: {
    dialog: Boolean,
    width: String,
    selectedMenu: Menu,
    submenus: Array as PropType<Menu[]>,
    hideSubmenuDialogClass: String,
  },
  data(): {
    locale: string;
    selectedSubmenu: Menu;
  } {
    return {
      locale: this.$i18n.locale,
      selectedSubmenu: null,
    };
  },
  computed: {
    submenuNameDataStr(): string {
      return "name." + this.locale;
    },
  },
  methods: {
    resetAndCloseDialog(): void {
      this.$emit("close");
      this.$emit("setSubmenu", null);
      this.selectedSubmenu = null;
    },
  },
});
